import { ITheme } from '../../models/ITheme';
import { ButtonTheme } from './ButtonTheme';
import { calculatorTheme } from './CalculatorTheme';
import { inputSpinnerTheme } from './inputSpinnerTheme';
import { inputTheme } from './inputTheme';
import { RatingTheme } from './RatingTheme';
import { TextTheme } from './TextTheme';

export const theme: ITheme = {
  Button: { ...ButtonTheme },
  Rating: { ...RatingTheme },
  Text: { ...TextTheme },
  Input: { ...inputTheme },
  InputSpinner: { ...inputSpinnerTheme },
  Calculator: { ...calculatorTheme },
} as const;
